import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	() =>
		createStyles({
			bodyChart: {
				paddingTop: 23,
				marginTop: 5,
				position: "relative"
			},
			chart: {
				background: "#ffffff50",
				height: 6,
				width: "100%",
				borderRadius: 10,
				position: "relative"
			},
			progressChart: {
				background:
					"linear-gradient(160.23deg, #BDFF69 7.85%, #11CF46 90.91%)",
				height: 6,
				borderRadius: 10
			},
			startPoint: {
				position: "absolute",
				left: -10,
				top: -7
			},
			endPoint: {
				position: "absolute",
				right: -8,
				top: -7,
				"& > img": {
					width: 20,
					height: 20
				}
			},
			progressPoint: {
				position: "absolute",
				top: 0,
				"& > img": {
					width: 20,
					height: 22
				}
			},
			icStartPoint: {
				position: "relative",
				"& > img": {
					width: 20,
					height: 20
				}
			},
			icSuccess: {
				position: "absolute",
				left: 5,
				top: 13,
				width: "10px !important",
				height: "10px !important"
			}
		}),
	{
		name: "Chart",
		index: 1
	}
);

export default useStyles;
